import { REVERSE_DATE_FORMAT } from 'constants/time.const';
import moment, { Moment } from 'moment';
import { addZeroPrefix } from './math.helper';

/**
 * get date with format 2016-05-06T00:06:00 -> 06/06/2016
 */
function formatDate(
  date: string | Moment | Date | undefined | null,
  format: string = REVERSE_DATE_FORMAT,
) {
  if (date && moment(date)?.isValid()) {
    return moment(date).format(format);
  }

  return '';
}

/**
 * Trả ra thời gian tính toán giữa hai mốc
 *
 * @category all Date
 * @param any
 * @param any
 * @returns Returns diff time.
 * @example
 *
 */
function diffFromDate(
  dTime1: Date | null | undefined,
  dTime2: Date | null | undefined,
  isExact = false,
): number | null {
  if (dTime1 && dTime2) {
    const _diff = moment(dTime1).diff(moment(dTime2), 'seconds');
    return isExact ? _diff : Math.abs(_diff);
  }
  return isExact ? null : 0;
}

/**
 * get date with format 6 -> 00:06
 *
 * get date with format 61 -> 01:01
 *
 * get date with format 3601 -> 01:00:01
 */
function secondToTimeFormat(second: number | undefined = 0): string {
  // eslint-disable-next-line no-param-reassign
  if (!second) second = 0;
  const hourNum = Math.floor(second / 3600);
  const minuteNum = Math.floor((second - hourNum * 3600) / 60);
  const secondNum = second - hourNum * 3600 - minuteNum * 60;
  return `${hourNum ? `${addZeroPrefix(hourNum, true)}:` : ''}${addZeroPrefix(
    minuteNum,
    true,
  )}:${addZeroPrefix(secondNum, true)}`;
}

function secToMil(second: number | undefined = 0): number {
  return (+second || 0) * 1000;
}

// Ckeck if current time is within a specified range
function checkTimeIsInRange(
  fromTime: string | undefined | null,
  toTime: string | undefined | null,
): boolean {
  if (!fromTime || !toTime) return true; // If no range is specified, consider it valid

  // Get current time
  const now = new Date();

  // Create Date objects for comparison (using today's date)
  const fromDate = new Date(now);
  const toDate = new Date(now);

  // Split the time strings into hours, minutes, seconds
  const [fromHours, fromMinutes, fromSeconds] = fromTime.split(':').map(Number);
  const [toHours, toMinutes, toSeconds] = toTime.split(':').map(Number);

  // Set the hours, minutes, seconds for comparison dates
  fromDate.setHours(fromHours, fromMinutes, fromSeconds, 0);
  toDate.setHours(toHours, toMinutes, toSeconds, 0);

  // Compare current time with the range
  if (now >= fromDate && now <= toDate) {
    return true;
  }

  return false;
}

export {
  formatDate,
  checkTimeIsInRange,
  diffFromDate,
  secondToTimeFormat,
  secToMil,
};
